import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import Model from './components/sections/Model';
import Thesis from './components/sections/Thesis';
import PartnersFounders from './components/sections/PartnersFounders';
import Portfolio from './components/sections/Portfolio';
import Founder from './components/sections/Founder';
import Inquiries from './components/sections/Inquiries';

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Model />
        <Thesis />
        <PartnersFounders />
        <Portfolio />
        <Founder />
        <Inquiries />
      </main>
      <Footer />
    </>
  );
}

export default App;
